var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tag-bar"},_vm._l((_vm.value),function(item){return _c('div',{key:item,staticClass:"tag-item"},[_c('span',[_vm._v(_vm._s(item))]),_c('i',{staticClass:"el-icon-close",on:{"click":function($event){return _vm.deleteVal(_vm.ind)}}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }